/**
 * If not logged in, start the wifi commissioning right away.
 *
 * Otherwise, redirect to devices page that explains this stuff
 * better for conflicting scenarios like demo users that should do
 * this whole process with their official accounts instead (or
 * request an invitation from their Workspace admin to get one).
 */
export function goToWifiCommissioning(vm) {
  vm.$api.trackWifiSetupStarted();
  if (vm.$store.getters.isLoggedIn) {
    vm.$router.push({name: 'devices'});
  } else {
    window.MYSHOPRADIO_APP_WRAPPER.startWifiCommissioning();
  }
}



// WEBPACK FOOTER //
// ./src/mixins/wifiCommissioning.js